export default __webpack_public_path__ + "static/media/Cellular_UID_ti40038.d65de628.png";